import { LatLng, LatLngBounds, point } from 'leaflet';

// Validation utilities
export const isValidNumber = (n: number) => !isNaN(n) && isFinite(n);
export const isValidLatLng = (l: LatLng) => isValidNumber(l.lat) && isValidNumber(l.lng);
export const isValidBounds = (b: LatLngBounds) => isValidLatLng(b.getNorthEast()) && isValidLatLng(b.getSouthWest());

export interface MapStatus {
	center: LatLng;
	zoom: number;
	bounds?: LatLngBounds;
}

export interface MapLimits {
	maxGlobalBounds: LatLngBounds;
	maxSubBounds: LatLngBounds;
	minZoom: number;
	maxZoom: number;
}

export interface SeedData {
	name: string;
	bbox: LatLngBounds;
	minZoom: number;
	maxZoom: number;
	queueLength: number;
	remainingLength?: number;
	zoomLevel?: number;
	size?: number;
}

export type SubLayerType = 'feature' | 'tile';
export interface OptionalLayer {
	enabled: boolean;
	name: string;
	title: string;
	transparent: boolean;
	type?: SubLayerType;
}

export type LayerType = 'wms' | 'osm' | 'gpkg' | 'geotiff' | 'grid' | 'geojson';
export type GpkgLayerStyle = 'standard' | 'standort' | 'humusform';

export interface GridStyle {
	color: string;
	fillColor: string;
	fillOpacity: number;
	radius: number;
}

export interface LayerDetails {
	type: LayerType;
	url: string;
	name: string;
	displayName?: string;  // Benutzerdefinierter Anzeigename (name bleibt als eindeutiger Schlüssel)
	isBase: boolean;
	transparent: boolean;
	layers?: OptionalLayer[];
	tileSize?: number;
	minZoom: number;
	maxZoom: number;
	maxNativeZoom?: number;
	bbox?: LatLngBounds;
	resolution?: number;
	display?: boolean;
	gpkgStyle?: GpkgLayerStyle;
	gridStyle?: GridStyle;
	wmsServerName?: string;  // Name des WMS-Servers (für Auth-Lookup)
}

export interface SeedableLayerDetails extends LayerDetails {
	minSeedZoom: number;
	maxSeedZoom: number;
	tilesCount: number;
	tilesMax: number;
}

export function makeCoords(x: number, y: number, z: number): L.Coords {
	return Object.assign(point(x, y), { z });
}
